module.exports = __webpack_public_path__ + "img/thumbnail_OldWorldSwallowtail_u_normal.2ae4f9ba.png";